/* eslint-disable max-len */
import {Units} from '../../../../components/Forms/Constants/CommonESGConstants/constants';
import {
  MaterialKey,
  MaterialLabel,
  EnergyConsumptionKey,
  EnergyConsumptionLabel,
  WaterAndEffluentsKey,
  WaterAndEffluentsLabel,
  BiodiversityKey,
  BiodiversityLabel,
  EmissionsKey,
  EmissionsLabel,
  WasteGenerationAndManagementKey,
  WasteGenerationAndManagementLabel,
  ComplianceKey,
  ComplianceLabel,
  SupplyChainKey,
  SupplyChainLabel
} from '../../../../components/Forms/Constants/Environmental/QuestionsKeyLabel';
import {inputType} from '../../interface/inputType';

export const materialsTabQuestions = [
  {
    key: '1',
    label: MaterialLabel.M_MATERIAL_1,
    kpiId: '301-1',
    items: [
      {
        question:
          'a. Total weight or volume of materials that are used to produce and package the organization’s primary products and services during the reporting period, by: ',
        tooltip:
          'The reported usage data are to reflect the material in its original state, and not to be presented with further data manipulation, such as reporting it as ‘dry weight’.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: MaterialKey.M_NON_RENEWABLE_MATERIALS_USED,
            fieldLabel: MaterialLabel.M_HEADING_1,
            units: [Units.weightUnits, Units.volumeUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MaterialKey.M_RENEWABLE_MATERIALS_USED,
            fieldLabel: MaterialLabel.M_HEADING_2,
            units: [Units.weightUnits, Units.volumeUnits]
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: MaterialLabel.M_MATERIAL_2,
    kpiId: '301-2',
    items: [
      {
        question:
          'a. Percentage of recycled input materials used to manufacture the organization’s primary products and services.',
        tooltip:
          'If material weight and volume measurements are stated as different units, the organization can convert measurements to standardized units.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: MaterialKey.M_TOTAL_RECYCLED_INPUT_MATERIALS_USED,
            fieldLabel: MaterialLabel.M_TOTAL_RECYCLED_INPUT_MATERIALS_USED
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MaterialKey.M_TOTAL_INPUT_MATERIALS_USED,
            fieldLabel: MaterialLabel.M_TOTAL_INPUT_MATERIALS_USED
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: MaterialLabel.M_MATERIAL_3,
    kpiId: '301-3',
    items: [
      {
        question:
          'a. Percentage of reclaimed products and their packaging materials for each product category',
        tooltip:
          'The reporting organization can also report recycling or reuse of packaging separately',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: MaterialKey.M_PRODUCT_RECLAIM_WITHIN_REPO_PERIOD,
            fieldLabel: MaterialLabel.M_PRODUCT_RECLAIM_WITHIN_REPO_PERIOD
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MaterialKey.M_PRODUCTS_SOLD_WITHIN_THE_REPORTING_PERIOD,
            fieldLabel:
              MaterialLabel.M_PRODUCTS_SOLD_WITHIN_THE_REPORTING_PERIOD
          }
        ]
      },
      {
        question: 'b. How the data for this disclosure have been collected.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              MaterialKey.M_HOW_THE_DATA_FOR_RECLAIMED_PRODUCTS_HAVE_BEEN_COLLECTED,
            fieldLabel:
              MaterialLabel.M_HOW_THE_DATA_FOR_RECLAIMED_PRODUCTS_HAVE_BEEN_COLLECTED
          }
        ]
      }
    ]
  }
];

export const energyConsumptionTabQuestions = [
  {
    key: '1',
    label: EnergyConsumptionLabel.EC_ENERGY_CONSUMPTION_1,
    kpiId: '302-1',
    items: [
      {
        question:
          'a. Total fuel consumption within the organization from non-renewable sources, in joules or multiples, and including fuel types used.',
        tooltip:
          '1. Avoid the double-counting of fuel consumption, when reporting self-generated energy consumption. If the organization generates electricity from a non-renewable or renewable fuel source and then consumes the generated electricity, the energy consumption shall be counted once under fuel consumption. 2. Report fuel consumption separately for non-renewable and renewable fuel sources. 3. Only report energy consumed by entities owned or controlled by the organization.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalFuelConsumptionWithinTheOrganizationFromNonRenewableSources',
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_TEXT,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_TEXT
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_NUMBER,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_NUMBER,
                  units: [
                    Units.weightUnits,
                    Units.volumeUnits,
                    Units.energyPowerElectricityUnits
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        question: '',
        tooltip:
          '1. Avoid the double-counting of fuel consumption, when reporting self-generated energy consumption. If the organization generates electricity from a non-renewable or renewable fuel source and then consumes the generated electricity, the energy consumption shall be counted once under fuel consumption. 2. Report fuel consumption separately for non-renewable and renewable fuel sources. 3. Only report energy consumed by entities owned or controlled by the organization.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            fieldLabel: 'a. Total fuel consumption within the organization...',

            formList: {
              name: 'totalFuelConsumptionWithinTheOrganizationFromRenewableSources',
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_TEXT,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_TEXT
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_NUMBER,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_NUMBER,
                  units: [
                    Units.weightUnits,
                    Units.volumeUnits,
                    Units.energyPowerElectricityUnits
                  ]
                }
              ]
            }
          }
        ]
      },
      {
        question: 'c. In joules, watt-hours or multiples, the total:',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_ELECTRICITY_CONSUMPTION,
            fieldLabel: EnergyConsumptionLabel.EC_ELECTRICITY_CONSUMPTION,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_HEATING_CONSUMPTION,
            fieldLabel: EnergyConsumptionLabel.EC_HEATING_CONSUMPTION,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_COOLING_CONSUMPTION,
            fieldLabel: EnergyConsumptionLabel.EC_COOLING_CONSUMPTION,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_STEAM_CONSUMPTION,
            fieldLabel: EnergyConsumptionLabel.EC_STEAM_CONSUMPTION,
            units: [Units.energyPowerElectricityUnits]
          }
        ]
      },
      {
        question: 'd. In joules, watt-hours or multiples, the total:',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_ELECTRICITY_SOLD,
            fieldLabel: EnergyConsumptionLabel.EC_ELECTRICITY_SOLD,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_HEATING_SOLD,
            fieldLabel: EnergyConsumptionLabel.EC_HEATING_SOLD,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_COOLIING_SOLD,
            fieldLabel: EnergyConsumptionLabel.EC_COOLIING_SOLD,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_STEAM_SOLD,
            fieldLabel: EnergyConsumptionLabel.EC_STEAM_SOLD,
            units: [Units.energyPowerElectricityUnits]
          }
        ]
      },
      {
        question:
          'e. Total energy consumption within the organization, in joules or multiples.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalEnergyConsumptionWithinOrganization',
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_TEXT,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_TEXT,
                  placeHolder: ''
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_NUMBER,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_NUMBER,
                  units: [Units.energyPowerElectricityUnits]
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'f. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_F,
            fieldLabel: EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_F
          }
        ]
      },
      {
        question: 'g. Source of the conversion factors used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_G,
            fieldLabel: EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_G
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: EnergyConsumptionLabel.EC_ENERGY_CONSUMPTION_2,
    kpiId: '302-2',
    items: [
      {
        question:
          'a. Energy consumption outside of the organization, in joules or multiples.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalEnergyConsumptionOutsideTheOrganization',
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_TEXT,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_TEXT,
                  placeHolder: ''
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_NUMBER,
                  fieldLabel:
                    EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_NUMBER,
                  units: [Units.energyPowerElectricityUnits]
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'b. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_B,
            fieldLabel: EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_B
          }
        ]
      },
      {
        question: 'c. Source of the conversion factors used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EnergyConsumptionKey.EC_TOTAL_CONSUMPTION_WITHIN_ORG_C,
            fieldLabel: EnergyConsumptionLabel.EC_TOTAL_CONSUMPTION_WITHIN_ORG_C
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: EnergyConsumptionLabel.EC_ENERGY_CONSUMPTION_3,
    kpiId: '302-3',
    items: [
      {
        question: 'a. Energy intensity ratio for the organization.',
        tooltip:
          'Intensity ratios can be provided for, among others:\n1. products (such as energy consumed per unit produced). 2. Services (such as energy consumed per function or per service). 3. Sales (such as energy consumed per monetary unit of sales). Organization-specific metrics (denominators) can include:\n4. Units of product. 5. Production volume (such as metric tons, liters, or MWh). 6. Size (such as m2 floor space). 7. Number of full-time employees. 8. Monetary units (such as revenue or sales)',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              EnergyConsumptionKey.EC_ENERGY_CONSUMED_IN_PRODUCTION_PROCESSES,
            fieldLabel:
              EnergyConsumptionLabel.EC_ENERGY_CONSUMED_IN_PRODUCTION_PROCESSES,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_ENERGY_CONSUMED_IN_OVERHEAD,
            fieldLabel: EnergyConsumptionLabel.EC_ENERGY_CONSUMED_IN_OVERHEAD,
            units: [Units.energyPowerElectricityUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EnergyConsumptionKey.EC_NORMALISATION_FACTOR,
            fieldLabel: EnergyConsumptionLabel.EC_NORMALISATION_FACTOR
          }
        ]
      },
      {
        question:
          'b. Organization-specific metric (the denominator) chosen to calculate the ratio.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EnergyConsumptionKey.EC_ENERGY_INTENSITY_B,
            fieldLabel: EnergyConsumptionLabel.EC_ENERGY_INTENSITY_B
          }
        ]
      },
      {
        question:
          'c. Types of energy included in the intensity ratio. whether fuel, electricity, heating, cooling, steam, or all.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EnergyConsumptionKey.EC_ENERGY_INTENSITY_C,
            fieldLabel: EnergyConsumptionLabel.EC_ENERGY_INTENSITY_C
          }
        ]
      },
      {
        question:
          'd. Whether the ratio uses energy consumption within the organization, outside of it, or both.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EnergyConsumptionKey.EC_ENERGY_INTENSITY_D,
            fieldLabel: EnergyConsumptionLabel.EC_ENERGY_INTENSITY_D
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: EnergyConsumptionLabel.EC_ENERGY_CONSUMPTION_4,
    kpiId: '302-4',
    items: [
      {
        question:
          'a. Amount of reductions in energy consumption achieved as a direct result of conservation and efficiency initiatives, in joules or multiples.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              EnergyConsumptionKey.EC_REDUCTION_OF_ENERGY_CONSUMPTION_A,
            fieldLabel:
              EnergyConsumptionLabel.EC_REDUCTION_OF_ENERGY_CONSUMPTION_A,
            units: [Units.energyPowerElectricityUnits]
          }
        ]
      },
      {
        question:
          'b. Types of energy included in the reductions. whether fuel, electricity, heating, cooling, steam, or all.',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName:
              EnergyConsumptionKey.EC_REDUCTION_OF_ENERGY_CONSUMPTION_B,
            fieldLabel:
              EnergyConsumptionLabel.EC_REDUCTION_OF_ENERGY_CONSUMPTION_B
          }
        ]
      },
      {
        question:
          'c. Basis for calculating reductions in energy consumption, such as base year or baseline, including the rationale for choosing it.',
        field: [
          {
            fieldType: inputType.DATEPICKER,
            fieldName:
              EnergyConsumptionKey.EC_REDUCTION_OF_ENERGY_CONSUMPTION_C,
            fieldLabel:
              EnergyConsumptionLabel.EC_REDUCTION_OF_ENERGY_CONSUMPTION_C
          }
        ]
      },
      {
        question:
          'd. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              EnergyConsumptionKey.EC_REDUCTION_OF_ENERGY_CONSUMPTION_D,
            fieldLabel:
              EnergyConsumptionLabel.EC_REDUCTION_OF_ENERGY_CONSUMPTION_D
          }
        ]
      }
    ]
  },
  {
    key: '5',
    label: EnergyConsumptionLabel.EC_ENERGY_CONSUMPTION_5,
    kpiId: '302-5',
    items: [
      {
        question:
          'a. Reductions in energy requirements of sold products and services achieved during the reporting period, in joules or multiples.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              EnergyConsumptionKey.EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_A,
            fieldLabel:
              EnergyConsumptionLabel.EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_A,
            units: [Units.energyPowerElectricityUnits]
          }
        ]
      },
      {
        question:
          'b. Basis for calculating reductions in energy consumption, such as base year or baseline, including the rationale for choosing it.',
        field: [
          {
            fieldType: inputType.DATEPICKER,
            fieldName:
              EnergyConsumptionKey.EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_B,
            fieldLabel:
              EnergyConsumptionLabel.EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_B
          }
        ]
      },
      {
        question:
          'c. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              EnergyConsumptionKey.EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_C,
            fieldLabel:
              EnergyConsumptionLabel.EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_C
          }
        ]
      }
    ]
  }
];

export const waterAndEffluentsTabQuestions = [
  {
    key: '1',
    label: WaterAndEffluentsLabel.WE_WATER_AND_EFFLUENTS_1,
    kpiId: '303-1',
    items: [
      {
        question:
          'a. A description of how the organization interacts with water, including how and where water is withdrawn, consumed, and discharged, and the water-related impacts the organization has caused or contributed to, or that are directly linked to its operations, products, or services by its business relationships (e.g., impacts caused by runoff).',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_A,
            tooltip: ''
          }
        ]
      },
      {
        question:
          'b. A description of the approach used to identify water-related impacts, including the scope of assessments, their timeframe, and any tools or methodologies used.',
        tooltip:
          'When assessing impacts, it is important that the organization consider its future impacts on water quality and availability, as these factors can change over time. Tools and methodologies for identifying impacts can include life cycle assessments, environmental impact assessments, water footprint assessments, scenario analysis, and stakeholder engagement. If information is estimated or modeled, rather than sourced from direct measurements, the organization can explain its estimation or modeling methods.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_B,
            fieldLabel:
              WaterAndEffluentsLabel.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_B
          }
        ]
      },
      {
        question:
          'c. A description of how water-related impacts are addressed, including how the organization works with stakeholders to steward water as a shared resource, and how it engages with suppliers or customers with significant water-related impacts.',
        tooltip:
          'Working with stakeholders is critical for an organization to steward water as a shared resource and account for the needs of other water users of the catchment. An organization’s stakeholders can include:• suppliers with significant water-related impacts.• users of its products and services.• local communities and action groups.• employees and other workers.• other water users in its sector or industry.• governments, regulators, and civil society organizations.• global initiatives, trade associations, and partnerships.The organization can describe how it participates in discussions with stakeholders, the frequency of this engagement, and its role in these discussions. Outcomes of working with stakeholders can include, for example, collective target-setting for water use, increased investment in infrastructure, policy advocacy, and capacity building and awareness raising.When reporting on its engagement with suppliers, the organization can describe:• how the organization engages with its suppliers to help them improve their water management practices.• the number of suppliers engaged.• the outcomes of this engagement.• the amount of procurement that the proportion of engaged suppliers represents.• why information is not requested from suppliers with significant water-related impacts.• future plans and goals for working with suppliers to reduce water-related impacts.Water impacts related to products and services might be addressed by, for example, improving product design, providing information and advice on the responsible use of products and services, and holding regular consultations with users.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_C,
            fieldLabel:
              WaterAndEffluentsLabel.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_C
          }
        ]
      },
      {
        question:
          'd. An explanation of the process for setting any water-related goals and targets that are part of the organization’s approach to managing water and effluents, and how they relate to public policy and the local context of each area with water stress.',
        tooltip:
          'Meaningful targets for managing water-related impacts:• account for the local context where water is withdrawn and discharged.• are scientifically informed by sustainable thresholds and the social context of a given catchment.• align with public sector efforts, such as the water- related targets of the UN Sustainable Development Goals, in particular Goal 6, or targets set by national and local government institutions.• are informed by the advocacy of other stakeholders, such as civil society organizations, trade associations, and action groups.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_D,
            fieldLabel:
              WaterAndEffluentsLabel.WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_D
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: WaterAndEffluentsLabel.WE_WATER_AND_EFFLUENTS_2,
    kpiId: '303-2',
    items: [
      {
        question:
          'A description of any minimum standards set for the quality of effluent discharge, and how these minimum standards were determined, including: ',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_A,
            fieldLabel: WaterAndEffluentsLabel.WE_HEADING_1,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_B,
            fieldLabel: WaterAndEffluentsLabel.WE_HEADING_2,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_C,
            fieldLabel: WaterAndEffluentsLabel.WE_HEADING_3,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_D,
            fieldLabel: WaterAndEffluentsLabel.WE_HEADING_4,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: WaterAndEffluentsLabel.WE_WATER_AND_EFFLUENTS_3,
    kpiId: '303-3',
    items: [
      {
        question:
          'a. Total water withdrawal from all areas in megaliters, and a breakdown of this total by the following sources, if applicable: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_SURFACE_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_SURFACE_WATER_A,
            tooltip:
              'Water that occurs naturally on the Earth’s surface in ice sheets, ice caps, glaciers, icebergs, bogs, ponds, lakes, rivers, and streams.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_GROUND_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_GROUND_WATER_A,
            tooltip:
              'Water that is being held in, and that can be recovered from, an underground formation.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_SEA_WATER_A,
            fieldLabel: WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_SEA_WATER_A,
            tooltip: 'Water in a sea or in an ocean.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_PRODUCED_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_PRODUCED_WATER_A,
            tooltip:
              'Water that enters the organization’s boundary as a result of extraction (e.g., crude oil), processing (e.g., sugar cane crushing), or use of any raw material, and has to consequently be managed by the organization.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_A,
            tooltip:
              'Municipal water suppliers and municipal wastewater treatment plants, public or private utilities, and other organizations involved in the provision, transport, treatment, disposal, or use of water and effluent.',
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'b. Total water withdrawal from all areas with water stress in megaliters, and a breakdown of this total by the following sources, if applicable: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_SURFACE_WATER_B,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_SURFACE_WATER_B,
            tooltip:
              'Water that occurs naturally on the Earth’s surface in ice sheets, ice caps, glaciers, icebergs, bogs, ponds, lakes, rivers, and streams.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_GROUND_WATER_B,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_GROUND_WATER_B,
            tooltip:
              'Water that is being held in, and that can be recovered from, an underground formation.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_SEA_WATER_B,
            fieldLabel: WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_SEA_WATER_B,
            tooltip: 'Water in a sea or in an ocean.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_PRODUCED_WATER_B,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_PRODUCED_WATER_B,
            tooltip:
              'Water that enters the organization’s boundary as a result of extraction (e.g., crude oil), processing (e.g., sugar cane crushing), or use of any raw material, and has to consequently be managed by the organization.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_B,
            fieldLabel:
              WaterAndEffluentsLabel.WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_B,
            tooltip:
              'Municipal water suppliers and municipal wastewater treatment plants, public or private utilities, and other organizations involved in the provision, transport, treatment, disposal, or use of water and effluent.',
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'c. A breakdown of total water withdrawal from each of the sources listed in Disclosures 303-3-a and 303-3-b in megaliters by the following categories: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_FRESH_WATER,
            fieldLabel:
              WaterAndEffluentsLabel.WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_FRESH_WATER,
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_OTHER_WATER,
            fieldLabel:
              WaterAndEffluentsLabel.WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_OTHER_WATER,
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'd. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              WaterAndEffluentsKey.WE_ANY_CONTEXTUAL_INFO_TO_UNDERSTAND_DATA_COMPILATION,
            fieldLabel:
              WaterAndEffluentsLabel.WE_ANY_CONTEXTUAL_INFO_TO_UNDERSTAND_DATA_COMPILATION
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: WaterAndEffluentsLabel.WE_WATER_AND_EFFLUENTS_4,
    kpiId: '303-4',
    items: [
      {
        question:
          'a. Total water discharge to all areas in megaliters, and a breakdown of this total by the following types of destination, if applicable: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_SURFACE_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_SURFACE_WATER_A,
            tooltip:
              'Water that occurs naturally on the Earth’s surface in ice sheets, ice caps, glaciers, icebergs, bogs, ponds, lakes, rivers, and streams.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_GROUND_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_GROUND_WATER_A,
            tooltip:
              'Water that is being held in, and that can be recovered from, an underground formation.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_SEA_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_SEA_WATER_A,
            tooltip: 'Water in a sea or in an ocean.',
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_THIRD_PARTY_WATER_A,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_THIRD_PARTY_WATER_A,
            tooltip:
              'Municipal water suppliers and municipal wastewater treatment plants, public or private utilities, and other organizations involved in the provision, transport, treatment, disposal, or use of water and effluent.',
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'b. A breakdown of total water discharge to all areas in megaliters by the following categories: ',
        tooltip:
          'The organization is required to provide a breakdown of the water discharged to all areas and to all areas with water stress by the categories freshwater and other water. Other water constitutes any water that has a concentration of total dissolved solids higher than 1,000 mg/L. Other water is therefore all water that does not fall into the freshwater category. The organization is, at a minimum, required to report a figure for other water discharged. The organization can additionally report any further breakdowns for other water discharge based on its water management and reporting practices, as long as it explains the approach used to define water quality using Disclosure 303-4-e. The organization can report additional information on how water quality has been determined, including consideration of the potential value of water to its users, as well as any absolute physical and/or chemical criteria used.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_B,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_B,
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_B,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_B,
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'c. Total water discharge to all areas with water stress in megaliters, and a breakdown of this total by the following categories: ',
        tooltip:
          'The organization is required to provide a breakdown of the water discharged to all areas and to all areas with water stress by the categories freshwater and other water. Other water constitutes any water that has a concentration of total dissolved solids higher than 1,000 mg/L. Other water is therefore all water that does not fall into the freshwater category. The organization is, at a minimum, required to report a figure for other water discharged. The organization can additionally report any further breakdowns for other water discharge based on its water management and reporting practices, as long as it explains the approach used to define water quality using Disclosure 303-4-e. The organization can report additional information on how water quality has been determined, including consideration of the potential value of water to its users, as well as any absolute physical and/or chemical criteria used.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_C,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_C,
            units: Units.megaLiterUnit
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              WaterAndEffluentsKey.WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_C,
            fieldLabel:
              WaterAndEffluentsLabel.WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_C,
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'd. Priority substances of concern for which discharges are treated, including: ',
        tooltip:
          'In the context of this Standard, substances of concern are those that cause irreversible damage to the waterbody, ecosystem, or human health. Discharge limits for substances of concern can be based on regulation and/or other factors determined by an organization. In countries where no regulations for discharge limits are available, the organization can develop its own discharge limits. ‘Discharge consent’ is the permission granted to an organization, allowing it to discharge a set amount of a substance. The organization can report any unauthorized discharges that exceed these limits using Disclosure 303-4-d. The organization can also describe any plans to reduce unauthorized discharges in the future.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_1,
            fieldLabel: WaterAndEffluentsLabel.WE_HEADING_5,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_2,
            fieldLabel: WaterAndEffluentsLabel.WE_HEADING_6,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_3,
            fieldLabel: WaterAndEffluentsLabel.WE_HEADING_7,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      },
      {
        question:
          'e. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_4,
            fieldLabel: WaterAndEffluentsLabel.WE_QUESTION_4
          }
        ]
      }
    ]
  },
  {
    key: '5',
    label: WaterAndEffluentsLabel.WE_WATER_AND_EFFLUENTS_5,
    kpiId: '303-5',
    items: [
      {
        question: 'a. Total water consumption from all areas in megaliters.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_5,
            fieldLabel: WaterAndEffluentsLabel.WE_QUESTION_5,
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'b. Total water consumption from all areas with water stress in megaliters.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_6,
            fieldLabel: WaterAndEffluentsLabel.WE_QUESTION_6,
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'c. change in water storage in megaliters, if water storage has been identified as having a significant water-related impact.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_7,
            fieldLabel: WaterAndEffluentsLabel.WE_QUESTION_7,
            units: Units.megaLiterUnit
          }
        ]
      },
      {
        question:
          'd. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used, including whether the information is calculated, estimated, modeled, or sourced from direct measurements, and the approach taken for this, such as the use of any sector-specific factors.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WaterAndEffluentsKey.WE_QUESTION_8,
            fieldLabel: WaterAndEffluentsLabel.WE_QUESTION_8
          }
        ]
      }
    ]
  }
];

export const biodiversityTabQuestions = [
  {
    key: '1',
    label: BiodiversityLabel.BD_BIODIVERSITY_1,
    kpiId: '304-1',
    items: [
      {
        question:
          'a. For each operational site owned, leased, managed in, or adjacent to, protected areas and areas of high biodiversity value outside protected areas, the following information: ',
        tooltip:
          'Monitoring which activities are taking place in both protected areas and areas of high biodiversity value outside protected areas makes it possible for the organization to reduce the risks of impacts. It also makes it possible for the organization to manage impacts on biodiversity or to avoid mismanagement.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: BiodiversityLabel.BD_HEADING_1
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'geographicLocations',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: BiodiversityKey.BD_QUESTION_1,
                  fieldLabel: BiodiversityLabel.BD_QUESTION_1,
                  placeHolder: ''
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: BiodiversityLabel.BD_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_2,
            fieldLabel: BiodiversityLabel.BD_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: BiodiversityLabel.BD_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_3,
            fieldLabel: BiodiversityLabel.BD_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: BiodiversityLabel.BD_HEADING_4
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'typeOfOperations',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: BiodiversityKey.BD_QUESTION_4,
                  fieldLabel: BiodiversityLabel.BD_QUESTION_4,
                  placeHolder: ''
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: BiodiversityLabel.BD_HEADING_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: BiodiversityKey.BD_QUESTION_5,
            fieldLabel: BiodiversityLabel.BD_QUESTION_5,
            units: [Units.areaUnits]
          },
          {
            fieldType: inputType.HEADING,
            heading: BiodiversityLabel.BD_HEADING_6
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_6,
            fieldLabel: BiodiversityLabel.BD_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading: BiodiversityLabel.BD_HEADING_7
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_7,
            fieldLabel: BiodiversityLabel.BD_QUESTION_7
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: BiodiversityLabel.BD_BIODIVERSITY_2,
    kpiId: '304-2',
    items: [
      {
        question:
          'a. Nature of significant direct and indirect impacts on biodiversity with reference to one or more of the following: ',
        tooltip:
          '• Indirect impacts on biodiversity can include impacts in the supply chain. • Areas of impact are not limited to areas that are formally protected and include consideration of impacts on buffer zones, as well as formally designated areas of special importance or sensitivity. • This disclosure provides the background for understanding (and developing) an organization’s strategy to mitigate significant direct and indirect impacts on biodiversity. By presenting structured and qualitative information, the disclosure enables comparison of the relative size, scale, and nature of impacts over time and across organizations.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_8,
            fieldLabel: BiodiversityLabel.BD_HEADING_8,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_9,
            fieldLabel: BiodiversityLabel.BD_HEADING_9,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_10,
            fieldLabel: BiodiversityLabel.BD_HEADING_10,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_11,
            fieldLabel: BiodiversityLabel.BD_HEADING_11,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_12,
            fieldLabel: BiodiversityLabel.BD_HEADING_12,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_13,
            fieldLabel: BiodiversityLabel.BD_HEADING_13,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      },
      {
        question:
          'b. Significant direct and indirect positive and negative impacts with reference to the following: ',
        tooltip:
          '• Indirect impacts on biodiversity can include impacts in the supply chain. • Areas of impact are not limited to areas that are formally protected and include consideration of impacts on buffer zones, as well as formally designated areas of special importance or sensitivity. • This disclosure provides the background for understanding (and developing) an organization’s strategy to mitigate significant direct and indirect impacts on biodiversity. By presenting structured and qualitative information, the disclosure enables comparison of the relative size, scale, and nature of impacts over time and across organizations.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_14,
            fieldLabel: BiodiversityLabel.BD_HEADING_14,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_15,
            fieldLabel: BiodiversityLabel.BD_HEADING_15,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_16,
            fieldLabel: BiodiversityLabel.BD_HEADING_16,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_17,
            fieldLabel: BiodiversityLabel.BD_HEADING_17,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: BiodiversityLabel.BD_BIODIVERSITY_3,
    kpiId: '304-3',
    items: [
      {
        question:
          'a. Size and location of all habitat areas protected or restored, and whether the success of the restoration measure was or is approved by independent external professionals.',
        tooltip:
          'This disclosure addresses the extent of an organization’s prevention and remediation activities with respect to its impacts on biodiversity. This disclosure refers to areas where remediation has been completed or where the area is actively protected. Areas where operations are still active can be counted if they conform to the definitions of ‘area restored’ or ‘area protected’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_18,
            fieldLabel: BiodiversityLabel.BD_QUESTION_18
          }
        ]
      },
      {
        question:
          'b. Whether partnerships exist with third parties to protect or restore habitat areas distinct from where the organization has overseen and implemented restoration or protection measures.',
        tooltip:
          'This disclosure addresses the extent of an organization’s prevention and remediation activities with respect to its impacts on biodiversity. This disclosure refers to areas where remediation has been completed or where the area is actively protected. Areas where operations are still active can be counted if they conform to the definitions of ‘area restored’ or ‘area protected’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_19,
            fieldLabel: BiodiversityLabel.BD_QUESTION_19
          }
        ]
      },
      {
        question:
          'c. Status of each area based on its condition at the close of the reporting period.',
        tooltip:
          'This disclosure addresses the extent of an organization’s prevention and remediation activities with respect to its impacts on biodiversity. This disclosure refers to areas where remediation has been completed or where the area is actively protected. Areas where operations are still active can be counted if they conform to the definitions of ‘area restored’ or ‘area protected’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_20,
            fieldLabel: BiodiversityLabel.BD_QUESTION_20
          }
        ]
      },
      {
        question: 'd. Standards, methodologies, and assumptions used.',
        tooltip:
          'This disclosure addresses the extent of an organization’s prevention and remediation activities with respect to its impacts on biodiversity. This disclosure refers to areas where remediation has been completed or where the area is actively protected. Areas where operations are still active can be counted if they conform to the definitions of ‘area restored’ or ‘area protected’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: BiodiversityKey.BD_QUESTION_21,
            fieldLabel: BiodiversityLabel.BD_QUESTION_21
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: BiodiversityLabel.BD_BIODIVERSITY_4,
    kpiId: '304-4',
    items: [
      {
        question:
          'a. Total number of IUCN Red List species and national conservation list species with habitats in areas affected by the operations of the organization, by level of extinction risk: ',
        tooltip:
          'This disclosure helps an organization to identify where its activities pose a threat to endangered plant and animal species. By identifying these threats, the organization can initiate appropriate steps to avoid harm and to prevent the extinction of species. The International Union for Conservation of Nature (IUCN) ‘Red List of Threatened Species’ (an inventory of the global conservation status of plant and animal species) and national conservation lists serve as authorities on the sensitivity of habitat in areas affected by operations, and on the relative importance of these habitats from a management perspective.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: BiodiversityKey.BD_QUESTION_22,
            fieldLabel: BiodiversityLabel.BD_QUESTION_22,
            units: [Units.extictionRiskLevelUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: BiodiversityKey.BD_QUESTION_23,
            fieldLabel: BiodiversityLabel.BD_QUESTION_23,
            units: [Units.extictionRiskLevelUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: BiodiversityKey.BD_QUESTION_24,
            fieldLabel: BiodiversityLabel.BD_QUESTION_24,
            units: [Units.extictionRiskLevelUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: BiodiversityKey.BD_QUESTION_25,
            fieldLabel: BiodiversityLabel.BD_QUESTION_25,
            units: [Units.extictionRiskLevelUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: BiodiversityKey.BD_QUESTION_26,
            fieldLabel: BiodiversityLabel.BD_QUESTION_26,
            units: [Units.extictionRiskLevelUnits]
          }
        ]
      }
    ]
  }
];

export const emissionsTabQuestions = [
  {
    key: '1',
    label: EmissionsLabel.E_EMISSIONS_1,
    kpiId: '305-1',
    items: [
      {
        question:
          'a. Gross direct (Scope 1) GHG emissions in metric tons of CO2 equivalent.',
        tooltip:
          '• exclude any GHG trades from the calculation of gross direct (Scope 1) GHG emissions• Direct (Scope 1) GHG emissions include, but are not limited to, the CO2 emissions from the fuel consumption as reported in Disclosure 302-1 of GRI 302: Energy.Direct (Scope 1) GHG emissions can come from the following sources owned or controlled by an organization:• Generation of electricity, heating, cooling and steam: these emissions result from combustion of fuels in stationary sources, such as boilers, furnaces, and turbines – and from other combustion processes such as flaring. • Physical or chemical processing: most of these emissions result from the manufacturing or processing of chemicals and materials, such as cement, steel, aluminum, ammonia, and waste processing. • Transportation of materials, products, waste, workers, and passengers: these emissions result from the combustion of fuels in mobile combustion sources owned or controlled by the organization, such as trucks, trains, ships, airplanes, buses, and cars. • Fugitive emissions: these are emissions that are not physically controlled but result from intentional or unintentional releases of GHGs. These can include equipment leaks from joints, seals, packing, and gaskets. methane emissions (e.g., from coal mines) and venting. HFC emissions from refrigeration and air conditioning equipment. and methane leakages (e.g., from gas transport).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_1,
            fieldLabel: EmissionsLabel.E_QUESTION_1,
            units: Units.carbonUnit
          }
        ]
      },
      {
        question:
          'b. Gases included in the calculation. whether CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, or all.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_2,
            fieldLabel: EmissionsLabel.E_QUESTION_2
          }
        ]
      },
      {
        question: 'c. Biogenic CO2 emissions in metric tons of CO2 equivalent.',
        tooltip:
          '• report biogenic emissions of CO2 from the combustion or biodegradation of biomass separately from the gross direct (Scope 1) GHG emissions. Exclude biogenic emissions of other types of GHG (such as CH4 and N2O), and biogenic emissions of CO2 that occur in the life cycle of biomass other than from combustion or biodegradation (such as GHG emissions from processing or transporting biomass).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_3,
            fieldLabel: EmissionsLabel.E_QUESTION_3,
            units: Units.carbonUnit
          }
        ]
      },
      {
        question: '',
        field: [
          {
            fieldType: inputType.DATEPICKER,
            fieldName: EmissionsKey.E_QUESTION_3_1,
            fieldLabel: EmissionsLabel.E_QUESTION_3_1,
            restrictFutureDateSelection: true,
            dateFormat: 'YYYY',
            pickerType: 'year'
          },
          {
            fieldType: inputType.HEADING,
            heading: EmissionsLabel.E_HEADING_11
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_4,
            fieldLabel: EmissionsLabel.E_HEADING_1,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_5,
            fieldLabel: EmissionsLabel.E_HEADING_2,
            heading: inputType.HEADING,
            colSpan: true,
            units: Units.carbonUnit
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_6,
            fieldLabel: EmissionsLabel.E_HEADING_3,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      },
      {
        question:
          'e. Source of the emission factors and the global warming potential (GWP) rates used, or a reference to the GWP source.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_7,
            fieldLabel: EmissionsLabel.E_QUESTION_7
          }
        ]
      },
      {
        question:
          'f. Consolidation approach for emissions. whether equity share, financial control, or operational control.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_8,
            fieldLabel: EmissionsLabel.E_QUESTION_8
          }
        ]
      },
      {
        question:
          'g. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_9,
            fieldLabel: EmissionsLabel.E_QUESTION_9
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: EmissionsLabel.E_EMISSIONS_2,
    kpiId: '305-2',
    items: [
      {
        question:
          'a. Gross location-based energy indirect (Scope 2) GHG emissions in metric tons of CO2 equivalent. ',
        tooltip:
          '• Energy indirect (Scope 2) GHG emissions include, but are not limited to, the CO2 emissions from the generation of purchased or acquired electricity, heating, cooling, and steam consumed by an organization – disclosed as specified in Disclosure 302-1 of GRI 302: Energy. For many organizations, the energy indirect (Scope 2) GHG emissions that result from the generation of purchased electricity can be much greater than their direct (Scope 1) GHG emissions.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_10,
            fieldLabel: EmissionsLabel.E_QUESTION_10,
            units: Units.carbonUnit
          }
        ]
      },
      {
        question:
          'b. If applicable, gross market-based energy indirect (Scope 2) GHG emissions in metric tons of CO2 equivalent.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_11,
            fieldLabel: EmissionsLabel.E_QUESTION_11,
            units: Units.carbonUnit
          }
        ]
      },
      {
        question:
          'c. If available, the gases included in the calculation. whether CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, or all.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_12,
            fieldLabel: EmissionsLabel.E_QUESTION_12
          }
        ]
      },
      {
        question: '',
        field: [
          {
            fieldType: inputType.DATEPICKER,
            fieldName: EmissionsKey.E_QUESTION_12_1,
            fieldLabel: EmissionsLabel.E_QUESTION_12_1,
            restrictFutureDateSelection: true,
            dateFormat: 'YYYY',
            pickerType: 'year'
          },
          {
            fieldType: inputType.HEADING,
            heading: EmissionsLabel.E_HEADING_11
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_13,
            fieldLabel: EmissionsLabel.E_HEADING_1,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_14,
            fieldLabel: EmissionsLabel.E_HEADING_2,
            heading: inputType.HEADING,
            colSpan: true,
            units: Units.carbonUnit
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_15,
            fieldLabel: EmissionsLabel.E_HEADING_3,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      },
      {
        question:
          'e. Source of the emission factors and the global warming potential (GWP) rates used, or a reference to the GWP source.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_16,
            fieldLabel: EmissionsLabel.E_QUESTION_16
          }
        ]
      },
      {
        question:
          'f. Consolidation approach for emissions. whether equity share, financial control, or operational control.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_17,
            fieldLabel: EmissionsLabel.E_QUESTION_17
          }
        ]
      },
      {
        question:
          'g. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_18,
            fieldLabel: EmissionsLabel.E_QUESTION_18
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: EmissionsLabel.E_EMISSIONS_3,
    kpiId: '305-3',
    items: [
      {
        question:
          'a. Gross other indirect (Scope 3) GHG emissions in metric tons of CO2 equivalent.',
        tooltip:
          'Other indirect (Scope 3) GHG emissions are a consequence of an organization’s activities, but occur from sources not owned or controlled by the organization. Other indirect (Scope 3) GHG emissions include both upstream and downstream emissions. Some examples of Scope 3 activities include extracting and producing purchased materials. transporting purchased fuels in vehicles not owned or controlled by the organization. and the end use of products and services. Other indirect emissions can also come from the decomposing of the organization’s waste. Processrelated emissions during the manufacture of purchased goods and fugitive emissions in facilities not owned by the organization can also produce indirect emissions.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_19,
            fieldLabel: EmissionsLabel.E_QUESTION_19,
            units: Units.carbonUnit
          }
        ]
      },
      {
        question:
          'b. If available, the gases included in the calculation. whether CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, or all.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_20,
            fieldLabel: EmissionsLabel.E_QUESTION_20
          }
        ]
      },
      {
        question: 'c. Biogenic CO2 emissions in metric tons of CO2 equivalent.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_21,
            fieldLabel: EmissionsLabel.E_QUESTION_21,
            units: Units.carbonUnit
          }
        ]
      },
      {
        question:
          'd. Other indirect (Scope 3) GHG emissions categories and activities included in the calculation.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_22,
            fieldLabel: EmissionsLabel.E_QUESTION_22
          }
        ]
      },
      {
        question: '',
        field: [
          {
            fieldType: inputType.DATEPICKER,
            fieldName: EmissionsKey.E_QUESTION_22_1,
            fieldLabel: EmissionsLabel.E_QUESTION_22_1,
            restrictFutureDateSelection: true,
            dateFormat: 'YYYY',
            pickerType: 'year'
          },
          {
            fieldType: inputType.HEADING,
            heading: EmissionsLabel.E_HEADING_11
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_23,
            fieldLabel: EmissionsLabel.E_HEADING_1,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_24,
            fieldLabel: EmissionsLabel.E_HEADING_2,
            heading: inputType.HEADING,
            colSpan: true,
            units: Units.carbonUnit
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_25,
            fieldLabel: EmissionsLabel.E_HEADING_3,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      },
      {
        question:
          'f. Source of the emission factors and the global warming potential (GWP) rates used, or a reference to the GWP source.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_26,
            fieldLabel: EmissionsLabel.E_QUESTION_26
          }
        ]
      },
      {
        question:
          'g. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_27,
            fieldLabel: EmissionsLabel.E_QUESTION_27
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: EmissionsLabel.E_EMISSIONS_4,
    kpiId: '305-4',
    items: [
      {
        question: 'a. GHG emissions intensity ratio for the organization.',
        tooltip:
          'Intensity ratios can be provided for, among others: • products (such as metric tons of CO2 emissions per unit produced).• services (such as metric tons of CO2 emissions per function or per service). • sales (such as metric tons of CO2 emissions per sales).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_28,
            fieldLabel: EmissionsLabel.E_QUESTION_28
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_29,
            fieldLabel: EmissionsLabel.E_QUESTION_29
          }
        ]
      },
      {
        question:
          'b. Organization-specific metric (the denominator) chosen to calculate the ratio.',
        tooltip:
          'Organization-specific metrics (denominators) can include: • units of product. • production volume (such as metric tons, liters, or MWh). • size (such as m2 floor space). • number of full-time employees. • monetary units (such as revenue or sales).',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_30,
            fieldLabel: EmissionsLabel.E_QUESTION_30
          }
        ]
      },
      {
        question:
          'c. Types of GHG emissions included in the intensity ratio. whether direct (Scope 1), energy indirect (Scope 2), and/or other indirect (Scope 3).',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_31,
            fieldLabel: EmissionsLabel.E_QUESTION_31
          }
        ]
      },
      {
        question:
          'd. Gases included in the calculation. whether CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, or all.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_32,
            fieldLabel: EmissionsLabel.E_QUESTION_32
          }
        ]
      }
    ]
  },
  {
    key: '5',
    label: EmissionsLabel.E_EMISSIONS_5,
    kpiId: '305-5',
    items: [
      {
        question:
          'a. GHG emissions reduced as a direct result of reduction initiatives, in metric tons of CO2 equivalent.',
        tooltip:
          'Reduction initiatives can include: • process redesign. • conversion and retrofitting of equipment. • fuel switching. • changes in behavior. • offsets.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_33,
            fieldLabel: EmissionsLabel.E_QUESTION_33,
            units: Units.carbonUnit
          }
        ]
      },
      {
        question:
          'b. Gases included in the calculation. whether CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, or all.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_34,
            fieldLabel: EmissionsLabel.E_QUESTION_34
          }
        ]
      },
      {
        question:
          'c. Base year or baseline, including the rationale for choosing it.',
        field: [
          {
            fieldType: inputType.DATEPICKER,
            fieldName: EmissionsKey.E_QUESTION_35,
            fieldLabel: EmissionsLabel.E_QUESTION_35,
            restrictFutureDateSelection: true,
            dateFormat: 'YYYY',
            pickerType: 'year'
          }
        ]
      },
      {
        question:
          'd. Scopes in which reductions took place. whether direct (Scope 1), energy indirect (Scope 2), and/or other indirect (Scope 3).',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_36,
            fieldLabel: EmissionsLabel.E_QUESTION_36
          }
        ]
      },
      {
        question:
          'e. Standards, methodologies, assumptions, and/or calculation tools used.',
        tooltip:
          'Reduction initiatives can include: • process redesign. • conversion and retrofitting of equipment. • fuel switching. • changes in behavior. • offsets.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_37,
            fieldLabel: EmissionsLabel.E_QUESTION_37
          }
        ]
      }
    ]
  },
  {
    key: '6',
    label: EmissionsLabel.E_EMISSIONS_6,
    kpiId: '305-6',
    items: [
      {
        question:
          'a. Production, imports, and exports of ODS in metric tons of CFC-11 (trichlorofluoromethane) equivalent.',
        tooltip:
          'Measuring ODS production, imports, and exports helps to indicate how an organization complies with legislation. This is particularly relevant if the organization produces or uses ODS in its processes, products and services and is subject to phase-out commitments. Results on ODS phase-out help to indicate the organization’s position in any markets affected by regulation on ODS',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_38,
            fieldLabel: EmissionsLabel.E_QUESTION_38,
            units: Units.metricTonsUnit
          }
        ]
      },
      {
        question: 'b. Substances included in the calculation.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_39,
            fieldLabel: EmissionsLabel.E_QUESTION_39
          }
        ]
      },
      {
        question: 'c. Source of the emission factors used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_40,
            fieldLabel: EmissionsLabel.E_QUESTION_40
          }
        ]
      },
      {
        question:
          'd. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_41,
            fieldLabel: EmissionsLabel.E_QUESTION_41
          }
        ]
      }
    ]
  },
  {
    key: '7',
    label: EmissionsLabel.E_EMISSIONS_7,
    kpiId: '305-7',
    items: [
      {
        question:
          'a. Significant air emissions, in kilograms or multiples, for each of the following: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_42,
            fieldLabel: EmissionsLabel.E_HEADING_4,
            heading: inputType.HEADING,
            colSpan: true,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_43,
            fieldLabel: EmissionsLabel.E_HEADING_5,
            heading: inputType.HEADING,
            colSpan: true,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_44,
            fieldLabel: EmissionsLabel.E_HEADING_6,
            heading: inputType.HEADING,
            colSpan: true,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_45,
            fieldLabel: EmissionsLabel.E_HEADING_7,
            heading: inputType.HEADING,
            colSpan: true,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_46,
            fieldLabel: EmissionsLabel.E_HEADING_8,
            heading: inputType.HEADING,
            colSpan: true,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmissionsKey.E_QUESTION_47,
            fieldLabel: EmissionsLabel.E_HEADING_9,
            heading: inputType.HEADING,
            colSpan: true,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_48,
            fieldLabel: EmissionsLabel.E_HEADING_10,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      },
      {
        question: 'b. Source of the emission factors used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_49,
            fieldLabel: EmissionsLabel.E_QUESTION_49
          }
        ]
      },
      {
        question:
          'c. Standards, methodologies, assumptions, and/or calculation tools used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmissionsKey.E_QUESTION_50,
            fieldLabel: EmissionsLabel.E_QUESTION_50
          }
        ]
      }
    ]
  }
];

export const wasteGenerationAndManagementTabQuestions = [
  {
    key: '1',
    label:
      WasteGenerationAndManagementLabel.WGAM_WASTE_GENERATION_AND_MANAGEMENT_1,
    kpiId: '306-1',
    items: [
      {
        question:
          'a. For the organization’s significant actual and potential waste-related impacts, a description of: ',
        tooltip:
          'When reporting on this disclosure, the organization can specify the types of inputs and outputs. The types of inputs and outputs can include raw materials, process and manufacturing materials, leaks and losses, waste, byproducts, products, or packaging.The organization can assess and report whether inputs, activities, and outputs lead or could lead to significant waste-related impacts using the following criteria:• Quantity of inputs used to produce the organization’s products or services, which will become waste after they are used for production.• Quantity of waste outputs generated in the organization’s own activities, or quantity of outputs it provides to entities downstream that will eventually become waste when they reach their end of life.• Hazardous characteristics of inputs and outputs. • Properties of input materials or design characteristics of outputs that limit or prevent their recovery or limit the length of their life. • Known potential negative threats associated with specific materials when they are discarded. For example, the potential threat of marine pollution resulting from leakage of discarded plastic packaging into waterbodies. • Types of activities that lead to significant quantities of waste generation or to generation of hazardous waste.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_1,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_HEADING_1,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_2,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_HEADING_2,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label:
      WasteGenerationAndManagementLabel.WGAM_WASTE_GENERATION_AND_MANAGEMENT_2,
    kpiId: '306-2',
    items: [
      {
        question:
          'a. Actions, including circularity measures, taken to prevent waste generation in the organization’s own activities and upstream and downstream in its value chain, and to manage significant impacts from waste generated.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_3,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_3,
            tooltip:
              'Actions, including circularity measures, to prevent waste generation and to manage significant impacts from waste generated can include:• Input material choices and product design:- Improving materials selection and product design through consideration for longevity and durability, repairability, modularity and disassembly, and recyclability.- Reducing the use of raw and finite materials by procuring secondary materials (e.g., used or recycled input materials) or renewable materials.- Substituting inputs that have hazardous characteristics with inputs that are nonhazardous.• Collaboration in the value chain and business model innovation:- Setting policies for procurement from suppliers that have sound waste prevention and waste management criteria.- Engaging in or setting up industrial symbiosis as a result of which the organization’s waste or other outputs (e.g., by-products from production) become inputs for another organization.- Participating in a collective or individual extended producer responsibility scheme or applying product stewardship, which extends the producer’s responsibility for a product or service to its end of life.- Transitioning to and applying new business models, such as product service systems that use services instead of products to meet consumer demand.- Engaging in or setting up product take-back schemes and reverse logistics processes to divert products and materials from disposal.'
          }
        ]
      },
      {
        question:
          'b. If the waste generated by the organization in its own activities is managed by a third party, a description of the processes used to determine whether the third party manages the waste in line with contractual or legislative obligations.',
        tooltip:
          'This disclosure can provide insight into the level of control the organization assumes for waste management outsourced to a third party. In the context of this Standard, a third party includes a public or private waste management organization, or any other entity or group of individuals formally or informally involved in handling the reporting organization’s waste. Waste management by third parties can include the collection, transportation, recovery, and disposal of waste, as well as the supervision of such operations and the aftercare of disposal sites. The organization may specify agreements in a contract for the third party to follow when managing its waste, or rely on existing legislative obligations, such as local environmental laws and regulations, to ensure that the third party manages the waste adequately.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_4,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_4
          }
        ]
      },
      {
        question:
          'c. The processes used to collect and monitor waste-related data.',
        tooltip:
          'The processes that the organization has in place for collecting and monitoring waste-related data can reflect its commitment to managing waste-related impacts. Such processes can include online data entry, maintaining a centralized database, real-time weighbridge measurement, and annual external data validation. The organization can specify whether the data collection and monitoring processes extend beyond waste generated in its own activities to include waste generated upstream and downstream in its value chain.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_5,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_5
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label:
      WasteGenerationAndManagementLabel.WGAM_WASTE_GENERATION_AND_MANAGEMENT_3,
    kpiId: '306-3',
    items: [
      {
        question:
          'a. Total weight of waste generated in metric tons, and a breakdown of this total by composition of the waste.',
        tooltip:
          'When reporting composition of the waste, the organization can describe:  • the type of waste, such as hazardous waste or nonhazardous waste. • the waste streams, relevant to its sector or activities (e.g., tailings for an organization in the mining sector, electronic waste for an organization in the consumer electronics sector, or food waste for an organization in the agriculture or in the hospitality sector). • the materials that are present in the waste (e.g., biomass, metals, non-metallic minerals, plastics, textiles).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementLabel.WGAM_QUESTION_6,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_6,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalWeightOfWasteGenerated',
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: WasteGenerationAndManagementLabel.WGAM_QUESTION_6_1
                },
                {
                  type: inputType.TEXT,
                  fieldName: WasteGenerationAndManagementLabel.WGAM_QUESTION_6_1
                },
                {
                  type: inputType.HEADING,
                  heading: WasteGenerationAndManagementLabel.WGAM_QUESTION_6_2
                },
                {
                  type: inputType.NUMBER,
                  fieldName: WasteGenerationAndManagementLabel.WGAM_QUESTION_6_2
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'b. Contextual information necessary to understand the data and how the data has been compiled.',
        tooltip:
          'To help understand the data, the organization can explain the reasons for the difference between the weight of waste generated and the weight of waste directed to recovery or disposal. This difference can be a result of precipitation or evaporation, leaks or losses, or other modifications to the waste. In the context of this Standard, leaks result from physical or technical failures (e.g., a trail of waste from a waste collection truck), while losses result from inadequate security measures or administrative failures (e.g., theft or lost records). To help understand how the data has been compiled, the organization can specify whether the data has been modeled or sourced from direct measurements, such as waste transfer notes from contracted waste collectors, external assurance, or audits of waste-related data.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_7,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_7
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label:
      WasteGenerationAndManagementLabel.WGAM_WASTE_GENERATION_AND_MANAGEMENT_4,
    kpiId: '306-4',
    items: [
      {
        question:
          'a. Total weight of waste diverted from disposal in metric tons, and a breakdown of this total by composition of the waste.',
        tooltip:
          'When reporting composition of the waste, the organization can describe: • the type of waste, such as hazardous waste or nonhazardous waste. • the waste streams, relevant to its sector or activities  (e.g., tailings for an organization in the mining  sector, electronic waste for an organization in the  consumer electronics sector, or food waste for an organization in the agriculture or in the hospitality sector). • the materials that are present in the waste (e.g., biomass, metals, non-metallic minerals, plastics, textiles).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementLabel.WGAM_QUESTION_8,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_8,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalWeightOfWasteDiverted',
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: WasteGenerationAndManagementLabel.WGAM_QUESTION_8_1
                },
                {
                  type: inputType.TEXT,
                  fieldName: WasteGenerationAndManagementLabel.WGAM_QUESTION_8_1
                },
                {
                  type: inputType.HEADING,
                  heading: WasteGenerationAndManagementLabel.WGAM_QUESTION_8_2
                },
                {
                  type: inputType.NUMBER,
                  fieldName: WasteGenerationAndManagementLabel.WGAM_QUESTION_8_2
                  // units: [Units.weightUnits]
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'b. Total weight of hazardous waste diverted from disposal in metric tons, and a breakdown of this total by the following recovery operations: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_9,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_9,
            tooltip:
              'When reporting on Disclosures 306-4-b-ii and 306-4- c-ii, the organization can specify the type of recycling operations, such as downcycling, upcycling, composting, or anaerobic digestion.',
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_10,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_10,
            tooltip:
              'Besides preparation for reuse and recycling, the organization can report the other types of recovery operations it uses under Disclosures 306-4-b-iii and 306-4-c-iii, such as repurposing or refurbishment.',
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_11,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_11
            // units: [Units.weightUnits]
          }
        ]
      },
      {
        question:
          'c. Total weight of non-hazardous waste diverted from disposal in metric tons, and a breakdown of this total by the following recovery operations: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_12,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_12,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_13,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_13,
            tooltip:
              'When reporting on Disclosures 306-4-b-ii and 306-4- c-ii, the organization can specify the type of recycling operations, such as downcycling, upcycling, composting, or anaerobic digestion.',
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_14,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_14,
            tooltip:
              'Besides preparation for reuse and recycling, the organization can report the other types of recovery operations it uses under Disclosures 306-4-b-iii and 306-4-c-iii, such as repurposing or refurbishment.',
            units: [Units.weightUnits]
          }
        ]
      },
      {
        question:
          'd. For each recovery operation listed in Disclosures 306-4-b and 306-4-c, a breakdown of the total weight in metric tons of hazardous waste and of non-hazardous waste diverted from disposal: ',
        tooltip:
          'Reporting on the quantity and type of waste diverted from disposal onsite and offsite shows the extent to which the organization knows how its waste is managed. In the context of this Standard, ‘onsite’ means within the physical boundary or administrative control of the reporting organization, and ‘offsite’ means outside the physical boundary or administrative control of the reporting organization.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_15,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_15,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_16,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_16,
            units: [Units.weightUnits]
          }
        ]
      },
      {
        question:
          'e. Contextual information necessary to understand the data and how the data has been compiled.',
        tooltip:
          'To help understand the data, the organization can explain the reasons for the difference between the weights of waste diverted from disposal onsite and offsite (e.g., lack of infrastructure onsite to recover materials from waste). It can also describe sector practices, sector standards, or external regulations that mandate a specific recovery operation. To help understand how the data has been compiled, the organization can specify whether the data has been modeled or sourced from direct measurements, such as waste transfer notes from contracted waste collectors, external assurance, or audits of waste-related data.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_17,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_17
          }
        ]
      }
    ]
  },
  {
    key: '5',
    label:
      WasteGenerationAndManagementLabel.WGAM_WASTE_GENERATION_AND_MANAGEMENT_5,
    kpiId: '306-5',
    items: [
      {
        question:
          'a. Total weight of waste directed to disposal in metric tons, and a breakdown of this total by composition of the waste.',
        tooltip:
          'When reporting composition of the waste, the organization can describe: • the type of waste, such as hazardous waste or nonhazardous waste. • the waste streams, relevant to its sector or activities (e.g., tailings for an organization in the mining sector, electronic waste for an organization inthe consumer electronics sector, or food waste for an organization in the agriculture or in the hospitality sector). • the materials that are present in the waste (e.g., biomass, metals, non-metallic minerals, plastics, textiles)',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_18,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_18,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalWeightOfWasteDirectedToDisposal',
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: WasteGenerationAndManagementLabel.WGAM_QUESTION_18_1
                },
                {
                  type: inputType.TEXT,
                  fieldName:
                    WasteGenerationAndManagementLabel.WGAM_QUESTION_18_1
                },
                {
                  type: inputType.HEADING,
                  heading: WasteGenerationAndManagementLabel.WGAM_QUESTION_18_2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    WasteGenerationAndManagementLabel.WGAM_QUESTION_18_2,
                  units: [Units.weightUnits]
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'b. Total weight of hazardous waste directed to disposal in metric tons, and a breakdown of this total by the following disposal operations: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_19,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_19,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_20,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_20,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_21,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_21,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_22,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_22,
            tooltip:
              'Besides incineration and landfilling, the organization can specify the other types of disposal operations it uses under Disclosures 306-5-b-iv and 306-5-c-iv, such as dumping, open burning, or deep well injection.',
            units: [Units.weightUnits]
          }
        ]
      },
      {
        question:
          'c. Total weight of non-hazardous waste directed to disposal in metric tons, and a breakdown of this total by the following disposal operations: ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_23,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_23,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_24,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_24,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_25,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_25,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_26,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_26,
            tooltip:
              'Besides incineration and landfilling, the organization can specify the other types of disposal operations it uses under Disclosures 306-5-b-iv and 306-5-c-iv, such as dumping, open burning, or deep well injection.',
            units: [Units.weightUnits]
          }
        ]
      },
      {
        question:
          'd. For each disposal operation listed in Disclosures 306-5-b and 306-5-c, a breakdown of the total weight in metric tons of hazardous waste and of non-hazardous waste directed to disposal: ',
        tooltip:
          'Reporting the quantity and type of waste directed to disposal onsite and offsite shows the extent to which the organization knows how its waste is managed. In the context of this Standard, ‘onsite’ means within the physical boundary or administrative control of the reporting organization, and ‘offsite’ means outside the physical boundary or administrative control of the reporting organization.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_27,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_27,
            units: [Units.weightUnits]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_28,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_28,
            units: [Units.weightUnits]
          }
        ]
      },
      {
        question:
          'e. Contextual information necessary to understand the data and how the data has been compiled.',
        tooltip:
          'To help understand the data, the organization can explain the reasons for the difference between the weights of waste directed to disposal onsite and offsite (e.g., local regulations that prohibit landfilling of specific types of waste). It can also describe sector practices, sector standards, or external regulations that mandate a specific disposal operation. To help understand how the data has been compiled, the organization can specify whether the data has been modeled or sourced from direct measurements, such as waste transfer notes from contracted waste collectors, external assurance, or audits of waste-related data.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WasteGenerationAndManagementKey.WGAM_QUESTION_29,
            fieldLabel: WasteGenerationAndManagementLabel.WGAM_QUESTION_29
          }
        ]
      }
    ]
  }
];

export const complianceTabQuestions = [
  {
    key: '1',
    label: ComplianceLabel.C_COMPLIANCE_1,
    kpiId: '307-1',
    items: [
      {
        question:
          'a. Significant fines and non-monetary sanctions for non-compliance with environmental laws and/or regulations in terms of:',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: ComplianceKey.C_QUESTION_1,
            fieldLabel: ComplianceLabel.C_QUESTION_1,
            units: [Units.currencyUnit]
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ComplianceKey.C_QUESTION_2,
            fieldLabel: ComplianceLabel.C_QUESTION_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ComplianceKey.C_QUESTION_3,
            fieldLabel: ComplianceLabel.C_QUESTION_3
          }
        ]
      },
      {
        question:
          'b. If the organization has not identified any non-compliance with environmental laws and/or regulations, a brief statement of this fact is sufficient.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ComplianceKey.C_QUESTION_4,
            fieldLabel: ComplianceLabel.C_QUESTION_4
          }
        ]
      }
    ]
  }
];

export const supplyChainTabQuestions = [
  {
    key: '1',
    label: SupplyChainLabel.SC_SUPPLY_CHAIN_1,
    kpiId: '308-1',
    items: [
      {
        question:
          'a. Percentage of new suppliers that were screened using environmental criteria.',
        tooltip:
          'This disclosure informs stakeholders about the percentage of suppliers selected or contracted subject to due diligence processes for environmental impacts. An organization is expected to initiate due diligenceas early as possible in the development of a new relationship with a supplier.Impacts may be prevented or mitigated at the stage of structuring contracts or other agreements, as well as via ongoing collaboration with suppliers.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_1,
            fieldLabel: SupplyChainLabel.SC_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_2,
            fieldLabel: SupplyChainLabel.SC_QUESTION_2
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: SupplyChainLabel.SC_SUPPLY_CHAIN_2,
    kpiId: '308-2',
    items: [
      {
        question: 'a. Number of suppliers assessed for environmental impacts.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_3
          }
        ]
      },
      {
        question:
          'b. Number of suppliers identified as having significant actual and potential negative environmental impacts',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_4,
            fieldLabel: SupplyChainLabel.SC_QUESTION_4
          }
        ]
      },
      {
        question:
          'c. Significant actual and potential negative environmental impacts identified in the supply chain. ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_5,
            fieldLabel: SupplyChainLabel.SC_QUESTION_5
          }
        ]
      },
      {
        question:
          'd. Percentage of suppliers identified as having significant actual and potential negative environmental impacts with which improvements were agreed upon as a result of assessment.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_6,
            fieldLabel: SupplyChainLabel.SC_QUESTION_6,
            heading: inputType.HEADING_5,
            colSpan: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_7,
            fieldLabel: SupplyChainLabel.SC_QUESTION_7,
            heading: inputType.HEADING_5,
            colSpan: true
          }
        ]
      },
      {
        question:
          'e. Percentage of suppliers identified as having significant actual and potential negative environmental impacts with which relationships were terminated as a result of assessment',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_8,
            fieldLabel: SupplyChainLabel.SC_QUESTION_8,
            heading: inputType.HEADING_5,
            colSpan: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplyChainKey.SC_QUESTION_9,
            fieldLabel: SupplyChainLabel.SC_QUESTION_9,
            heading: inputType.HEADING_5,
            colSpan: true
          }
        ]
      }
    ]
  }
];
